<template>
	<div
		:class="classList"
		aria-hidden="true"
	/>
</template>

<script>
export default {
	name: 'BaseRipple',
	data: () => ({
		isAnimating: false
	}),
	computed: {
		classList () {
			return [
				[this.$style.ripple],
				{
					[this.$style['ripple--animate']]: this.isAnimating
				}
			]
		}
	},
	created () {
		if (this.$parent) {
			this.$parent.$on('click', this.handleClick)
		}
	},
	beforeDestroy () {
		if (this.$parent) {
			this.$parent.$off('click', this.handleClick)
		}
	},
	methods: {
		handleClick (event) {
			this.isAnimating = false
			const parentEl = this.$parent.$el
			const rippleEl = this.$el

			this.$nextTick(() => {
				// Ensure ripple covers the whole element
				if (!rippleEl.offsetHeight && !rippleEl.offsetWidth) {
					const d = Math.max(parentEl.offsetHeight, parentEl.offsetWidth)
					rippleEl.style.height = `${d}px`
					rippleEl.style.width = `${d}px`
				}

				// Calculate position relative to the button, not the window
				const parentRect = parentEl.getBoundingClientRect()

				// Mouse position relative to the button
				const x = event.clientX - parentRect.left - (rippleEl.offsetWidth / 2)
				const y = event.clientY - parentRect.top - (rippleEl.offsetHeight / 2)

				rippleEl.style.top = `${y}px`
				rippleEl.style.left = `${x}px`
				this.isAnimating = true
			})
		}
	}
}
</script>

<style lang="scss" module>
.ripple {
    display: block;
    position: absolute;
    background: currentcolor;
    border-radius: 50%; /* 100% works too, but 50% is standard for circle */
    transform: scale(0);
    will-change: transform, opacity;
    opacity: 0.3;
    pointer-events: none; /* Important: prevents blocking clicks */
    z-index: 1; /* Sits below content */

    &--animate {
        animation: ripple 0.6s linear;
    }
}

@keyframes ripple {
    0% {
        transform: scale(0);
    }

    100% {
        opacity: 0;
        transform: scale(2.5);
    }
}
</style>
